import * as actionTypes from './actionTypes';
import admSvc from '../../axios-admsvc';
import {addMemberEligibilitySuccess, updateCache, selectMember} from "./member";
import * as urls from '../../shared/ApplicationUrls';
import {concatePortals, getEnabledPortalUrl} from '../../shared/utility';
import { findProcessError } from '../../shared/ProcessError';
import { SDK_PORTAL_LIST } from '../../shared/Constants';

//fetch portals
export const fetchEligibilityPortals = () => {
    // console.log("[Add Eligibility] Fetch Eligibility Portals Start ");
    return (dispatch, getState) => {
        dispatch(fetchEligibilityPortalsStart());
        dispatch(fetchEligPortalInfoStart());
        admSvc.get(getEnabledPortalUrl(true,urls.FETCH_ELIGIBILITY_PORTALS))
            .then(response => {
                // console.log("[Add Eligibility] Fetch Account Portals Response: ",response.data);
                let portals = response.data.portals;
                let sdkPortalList = getState().member.sdkPortalList;
                if (!sdkPortalList || !sdkPortalList.length){
                    sdkPortalList = JSON.parse(localStorage.getItem(SDK_PORTAL_LIST));
                }
                portals = concatePortals(portals, sdkPortalList, "addEligibility");
                dispatch(fetchEligibilityPortalsSuccess(portals));
                dispatch(fetchEligPortalsInfo(portals));
            })
            .catch(error => {
                // console.log("[Reference Data] Fetch Portals Error: ", error);
                dispatch(fetchEligibilityPortalsFailure(error));
                // return Promise.reject(error.response);
                return error.response;
            });
    }

}

export const fetchEligibilityPortalsStart = () => {
    return {
        type: actionTypes.FETCH_ELIG_PORTALS_START
    }
}

export const fetchEligibilityPortalsSuccess = (portals) => {
    // console.log("[Add Elig Actions] Fetch Elig Portals Success: ", portals);
    return {
        type: actionTypes.FETCH_ELIG_PORTALS_SUCCESS,
        portals: portals.sort((a, b) => (a.portalDisplayName > b.portalDisplayName) ? 1 : -1)
    }
}

export const fetchEligibilityPortalsFailure = (error) => {
    return {
        type: actionTypes.FETCH_ELIG_PORTALS_FAILURE,
        error: error
    }
}

export const fetchDisabledPortals = () => {
    return dispatch => {
        admSvc.get("/portals/decoupled")
        .then(response => {
            console.log(response);
            let portals = response.data;
            dispatch(fetchDisabledPortalsSuccess(portals));
        })
    }
}

export const fetchDisabledPortalsSuccess = (portals) => {
    return {
        type: actionTypes.FETCH_DISABLED_PORTAL_SUCCESS,
        payload: portals
    }
} 

// fetch portal Info
export const fetchEligPortalsInfo = (portals) => {
    // console.log("[Add Eligibility Action] fetchEligPortalsInfo", portals.length, portals);
    return dispatch => {
        // dispatch(fetchPortalInfoStart());
        portals.map((portal, index, portals) => {
            // console.log("[Add Eligibility Action] fetchEligPortalsInfo loop ", portal.prtlId, index, portals.length-1);
            return dispatch(fetchEligPortalInfo(portal));
        });
    }
}

export const fetchEligPortalInfoStart = () => {
    return {
        type: actionTypes.FETCH_ELIG_PORTAL_INFO_START
    }
}



export const fetchEligPortalInfo = (portal) => {
    // console.log("[Add Eligbility Action ] Fetch Portal Info start: ", portalId);
    return dispatch => {
        if (!portal.prtlId || portal.prtlId === 1337) {
            return dispatch(fetchEligPortalInfoSuccess(portal));
        }
        admSvc.get(urls.FETCH_ELIGIBILITY_PORTAL_INFO+portal.prtlId).then(response => {
            // console.log("[Add Eligbility Action] Fetch Portal Info Response: ",response.data);
            dispatch(fetchEligPortalInfoSuccess(response.data));
            // if(lastPortal) {dispatch(fetchEligPortalInfoToggle());}
        }).catch(error => {
            // console.log("[Add Eligbility Action] Fetch Portal Info Error: ", portalId, error);
            dispatch(fetchEligPortalInfoFailure(error));
            // if(lastPortal) {dispatch(fetchEligPortalInfoToggle());}
            // return Promise.reject(error.response);
            return error.response;
        });
    }
}

export const fetchEligPortalInfoSuccess = (portalInfo) => {
    return {
        type: actionTypes.FETCH_ELIG_PORTAL_INFO_SUCCESS,
        portalInfo: portalInfo,
    }
}


export const fetchEligPortalInfoFailure = (error) => {
    return {
        type: actionTypes.FETCH_ELIG_PORTAL_INFO_FAILURE,
        error: error,
    }
}

// add bank eligibility

export const addBankEligibility = (memberInfo, history, operation) => {
    return dispatch => {
        dispatch(fetchFaroIdStart());
        const ahsRequest = {
            "firstName": memberInfo.FirstName,
            "lastName": memberInfo.LastName,
            "zipCode": memberInfo.ZipCode,
            "dateOfBirth": memberInfo.DOB,
            "ssn": memberInfo.SSN,
            "employeeId": memberInfo.SubscriberId,
            "filterDetails":true
        };
        admSvc.post("/members/external", ahsRequest,).then(response => {
            //console.log("[AddEligibility] AHS Search Response: ",response.data);
            if(response.data.faroId) {
                dispatch(fetchFaroIdSuccess(response.data.faroId, operation));
                dispatch(addEligibility({...memberInfo, subscriberId: response.data.faroId}, history, operation));
            } else if(response.data.status === 'error'){
                dispatch(fetchFaroIdFailure("No user found in Optum Bank", operation));
            } else {
                dispatch(fetchFaroIdFailure("It took longer than expected to validate the user. Pls try again.", operation));
            }
        }).catch(error => {
           // console.log("[AddEligibility] Error during AHS Search: ", error);
            dispatch(fetchFaroIdFailure(error, operation));
            // return Promise.reject(error.response);
            return error.response;
        });
    }
}

export const fetchFaroId = (memberInfo, operation) => {
    return dispatch => {
        dispatch(fetchFaroIdStart());
        const ahsRequest = {
            "firstName": memberInfo.FirstName,
            "lastName": memberInfo.LastName,
            "dateOfBirth": memberInfo.DOB,
            "zipCode": memberInfo.ZipCode,
            "ssn": memberInfo.SSN,
            "employeeId": memberInfo.SubscriberId,
            "filterDetails":true,
            "uuid": memberInfo.uuid,
            "userName": memberInfo.userName
        };
        admSvc.post("/members/external", ahsRequest,).then(response => {
            //console.log("[AddEligibility] AHS Search Response: ",response.data);
            if(response.data.faroId) {
                dispatch(fetchFaroIdSuccess(response.data.faroId, operation));
            } else if(response.data.status === 'error'){
                dispatch(fetchFaroIdFailure("No user found in Optum Bank.", operation));
            } else {
                dispatch(fetchFaroIdFailure("It took longer than expected to validate the user. Pls try again.", operation));
            }
        }).catch(error => {
            // console.log("[AddEligibility] Error during AHS Search: ", error);
            dispatch(fetchFaroIdFailure(error, operation));
            // return Promise.reject(error.response);
            return error.response;
        });
    }
}

export const fetchFaroIdStart = () => {
    return {
        type: actionTypes.FETCH_ELIG_FARO_ID_START
    }
}

export const fetchFaroIdSuccess = (faroId, operation) => {
    return {
        type: actionTypes.FETCH_ELIG_FARO_ID_SUCCESS,
        faroId: faroId,
        operation: operation
    }
}

export const fetchFaroIdFailure = (error, operation) => {
    return {
        type: actionTypes.FETCH_ELIG_FARO_ID_FAILURE,
        error: error,
        operation: operation
    }
}

export const fetchGroupId = (memberInfo, operation) => {
    return dispatch => {
        dispatch(fetchGroupIdStart());
        const myuhcMemberDataRequest = {
            "firstName": memberInfo.FirstName,
            "lastName": memberInfo.LastName,
            "dob": memberInfo.DOB,
            "zipCode" : memberInfo.ZipCode,
            "memberId": memberInfo.SubscriberId,
            "portalIndicator": memberInfo.portalIndicator,
            "parentPortal": memberInfo.targetPortal,
            "uuid": memberInfo.uuid,
            "userName": memberInfo.userName

         };
         delete memberInfo["portalIndicator"];
        admSvc.post("/members/fetch/groupId", myuhcMemberDataRequest,).then(response => {
            //console.log("[AddEligibility] MYUHC sub portal Search Response: ",response.data);
            if(response.data.groupId) {
                dispatch(fetchGroupIdSuccess(response.data.groupId, operation));
            } else if(response.data.status === 'error'){
                dispatch(fetchGroupIdFailure(response.data.msg, operation));
            } else {
                dispatch(fetchGroupIdFailure("It took longer than expected to validate the user. Pls try again.", operation));
            }
        }).catch(error => {
            // console.log("[AddEligibility] Error during MYUHC sub portal Search: ", error);
            dispatch(fetchGroupIdFailure("No user found.", operation));
            // return Promise.reject(error.response);
            return error.response;
        });
    }
}

export const fetchGroupIdStart = () => {
    return {
        type: actionTypes.FETCH_ELIG_GROUP_ID_START
    }
}

export const fetchGroupIdSuccess = (groupId, operation) => {
    return {
        type: actionTypes.FETCH_ELIG_GROUP_ID_SUCCESS,
        groupId: groupId,
        operation: operation
    }
}

export const fetchGroupIdFailure = (error, operation) => {
    return {
        type: actionTypes.FETCH_ELIG_GROUP_ID_FAILURE,
        error: error,
        operation: operation
    }
}

// add eligibility
export const addEligibility = (memberInfo, history, operation, idType) => {
    return dispatch => {
        dispatch(addEligibilityStart());
        // console.log("Member Info in Add Eligibility: ", memberInfo);
        admSvc.post(urls.ADD_ELIGIBILITY, memberInfo).then(response => {
            // console.log("[AddEligibility] AddEligibility Response: ", response.data, response.data[0], response.data[0].memberPortalAttributeList[0]);
            let eligInfo = {"uuid": memberInfo.healthSafeId}
            if(memberInfo.targetPortal === "YTTH" && response.data[0] && response.data[0].error) {
                dispatch(addEligibilityFailure({message: response.data[0].error}, operation));
            } else {
                dispatch(addEligibilitySuccess(operation));
                dispatch(selectMember(eligInfo));
                dispatch(addMemberEligibilitySuccess(operation));
                // healthSafeId
                if(memberInfo.targetPortal !== "YTTH"){
                    dispatch(updateCache(memberInfo.healthSafeId));
                }
                history.push({
                    pathname:`/member/${btoa(memberInfo.healthSafeId)}/${idType}`,
                    state: {idType: idType}
                });
            }
        }).catch(error => {
            // console.log("[AddEligibility] Error during AddEligibility: ", error);
            // this.setState({loading: false, error: {message: "API call failed"}});
            dispatch(addEligibilityFailure({message: "Add Eligibility failed. Pls try again"}, operation));
            // return Promise.reject(error.response);
            return error.response;
        });
    }
}

export const addSdkEligibility = (memberInfo, history, operation, idType) => {
    return dispatch => {
        // console.log("[addSdkEligibility] inside dispatch");
        dispatch(addEligibilityStart());
        let eligibilityUrl = memberInfo.userPortalDetails.isPePortal ? urls.ADD_PE_ELIGIBILITY : urls.ADD_SDK_ELIGIBILITY;
        
        // console.log("Member Info in Add Eligibility: ", memberInfo);
        admSvc.post(eligibilityUrl, memberInfo).then(response => {
            // console.log("[addSdkEligibility] AddEligibility Response: ", response);
            let eligInfo = {
                uuid: memberInfo.uuid,
                targetPortal: memberInfo.userPortalDetails.portal
            }
            if(!response.data || !response.data.status || response.data.status.code !== "200") {
                dispatch(addEligibilityFailure({message: "Add Eligibility failed. Pls try again"}, operation));
            } else {
                if (response.data.payload && response.data.payload.status === "ELIGIBLE") {
                    dispatch(addEligibilitySuccess(operation));
                    dispatch(selectMember(eligInfo));
                    dispatch(addMemberEligibilitySuccess(operation));
                    history.push({
                        pathname:`/member/${btoa(memberInfo.uuid)}/${idType}`,
                        state: {idType: idType}
                    });
                } else {
                    const error = response.data.payload ? response.data.payload.error : "UNKNOWN_EXCEPTION" ;
                    dispatch(addEligibilityFailure({message: findProcessError(error)}, operation));
                }            
            }
        }).catch(error => {
            // console.log("[AddEligibility] Error during AddEligibility: ", error);
            // this.setState({loading: false, error: {message: "API call failed"}});
            dispatch(addEligibilityFailure({message: "Add Eligibility failed. Pls try again"}, operation));
            // return Promise.reject(error.response);
            return error.response;
        });
    }
}

export const addEligibilityStart = () => {
    return {
        type: actionTypes.ADD_ELIGIBILITY_START,
    }
}

export const addEligibilitySuccess = (operation) => {
    return {
        type: actionTypes.ADD_ELIGIBILITY_SUCCESS,
        operation: operation
    }
}

export const addEligibilityFailure = (error, operation) => {
    return {
        type: actionTypes.ADD_ELIGIBILITY_FAILURE,
        error: error,
        operation: operation
    }
}

export const setAddEligibilityPortal = (portalInfo) => {
    return {
        type: actionTypes.SET_ADD_ELIGIBILITY_PORTAL,
        portalInfo: portalInfo
    }
}

export const setEligDisplayMessage = (message) => {
    return {
        type: actionTypes.SET_ELIG_DISPLAY_MESSAGE,
        message: message
    }
}

export const setModifyEligibilityPortal = (portal, history) => {
    // console.log("[Add Eligibility Action]", portal);
    // if(history) {
    //     history.push("/modifyEligibility");
    // }
    return {
        type: actionTypes.SET_MODIFY_ELIGIBILITY_PORTAL,
        portal: portal
    }
}

export const setModifyEligibilitySelectedPortal = (portal) => {
    return {
        type: actionTypes.SET_MODIFY_ELIGIBILITY_SELECTED_PORTAL,
        portal: portal
    }
}

export const setModifyEligibilityMessage = (message) => {
    return {
        type: actionTypes.MODIFY_PORTAL_ELIGIBILITY_MESSAGE,
        message: message
    }
}

export const setMemberEligMsgToNull = () => {
    return {
        type: actionTypes.SET_MEMBER_ELIG_MESSAGE,
    }
}

export const toggleModifyEligModal = () => {
    // console.log("[Add Eligibility] toggleModifyEligModal");
    return {
        type: actionTypes.MODIFY_ELIGIBILITY_MODAL_TOGGLE
    }
}

export const toggleAddEligModal = () => {
    // console.log("[Add Eligibility] toggleAddEligModal");
    return {
        type: actionTypes.ADD_ELIGIBILITY_MODAL_TOGGLE
    }
}

export const mergePortalInfo = (portalInfo, portalConfigPortals) => {
    if(portalConfigPortals) {
        portalConfigPortals.foreach(portal => {
            portalInfo = {
                ...portalInfo,
                [portal.portalShortName] : portal
            }
        });
    }
    return {
        type: actionTypes.MERGE_PORTALS_INFO,
        portalInfo: portalInfo
    }
}

export const mergePortalList = (portalsList, portalConfigPortalList) => {
    portalConfigPortalList.foreach(portal => {
        portalsList.push(portal)
    });
    return {
        type: actionTypes.MERGE_PORTALS_LIST,
        portalsList: portalsList
    }
}
